<template>
  <div class="footer">
    <h5>Copyright &copy; {{year}} by PT Beo Teknologi Suara</h5>
  </div>
</template>
<script>
export default {
  name: 'TheFooter',
  data(){
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
